import { OrderByType } from '@v2/commons/interface/enums'

import { IEscalationFilters } from '../escalation.types'

export const buildOrderByString = (
  field: string,
  orderBy: OrderByType,
): string | undefined => {
  if (!field || !orderBy) return 'task.createdAt DESC'
  if (field === 'user.name') {
    field = 'person.lastName'
  }
  return `${field} ${orderBy}`
}

export const buildEscalationQueryParams = (
  filters: IEscalationFilters,
  page: number,
  limit: number,
): IEscalationFilters => {
  return {
    ...filters,
    offset: page * limit,
    limit,
  }
}
